
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.25 3.438a.69.69 0 01.688.687v13.741l-.215-.279-5.844-7.562a1.034 1.034 0 00-1.633 0L8.68 14.639l-1.31-1.834a1.025 1.025 0 00-.839-.43c-.335 0-.644.159-.838.434l-3.437 4.813-.193.266V4.125a.69.69 0 01.687-.688h16.5zM2.75 1.374A2.753 2.753 0 000 4.125v13.75a2.753 2.753 0 002.75 2.75h16.5a2.753 2.753 0 002.75-2.75V4.125a2.753 2.753 0 00-2.75-2.75H2.75zm3.438 8.25a2.062 2.062 0 100-4.125 2.062 2.062 0 000 4.125z","fill":"#D5DBE3"}})])
          )
        }
      }
    